import React from "react";
import { Modal } from "react-bootstrap";
import { Apiurl } from "../../Pages/utils/page";
import { ClipLoader } from "react-spinners";

const UploadAndListingEditBannerModal = ({
  changeBannerModal,
  handleCloseEditBannerModal,
  bannerDataImage,
  changeData,
  setChangeData,
  handleUpdateBanner,
  loading
}) => {
  return (
    <Modal
      show={changeBannerModal}
      onHide={handleCloseEditBannerModal}
      backdrop="static"
      className="editproductModal"
    >
      <Modal.Header closeButton>
        <h4 className="modal-title common_heading">Change Product Banner</h4>
      </Modal.Header>
      <Modal.Body className="popup_body_scroll">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <div className="product_banner">
                <div className="product_top_section_edit">
                  {bannerDataImage?.map((item) => {
                    const banner = item?.BannerUrl.split('"');
                    const bannerUrl = `${Apiurl()}/${banner?.[1]}`;
                    return (
                      <div
                        className={
                          changeData?.BannerId == item?.Id
                            ? "product-banner_wdth_edit selected_Banner"
                            : "product-banner_wdth_edit"
                        }
                      >
                        <div className="mb-3">
                          <img
                            src={bannerUrl}
                            onError={(e) => {
                              e.target.onerror = null; 
                              e.target.src =
                                "/Images/banner-default.jpg"
                            }} 
                          />
                          <div>
                            <input
                              type="checkbox"
                              id={item?.Id}
                              checked={item?.Id == changeData?.BannerId}
                              onChange={() =>
                                setChangeData({
                                  ...changeData,
                                  BannerId: item?.Id,
                                })
                              }
                            />
                            <label for={item?.Id}>Change To This Banner</label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {loading=="updateBanner"?
                 <button type="button" className="common_btn view-data-btn" >
                  
                  <ClipLoader
                              className="main_loader_home"
                              loading
                              size={15}
                            />               </button>
            :
            <button type="button" className="common_btn view-data-btn" onClick={handleUpdateBanner}>
                  
            Change Banner
          </button>
            }
               
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default UploadAndListingEditBannerModal;
